<template>
	<!-- 販売停止/代替商品 で、カート追加テキストがある場合 -->
	<div class="cartContainer sort-item" v-if="!(ptInitData.productInfo.FORM_LP_FLG == 1 && isLp) && doChkCartAddTxt && ptInitData.productInfo.CART_ADD_TEXT">
		<div class="notSalesKbnText text-danger">
			{{ ptInitData.productInfo.CART_ADD_TEXT }}
		</div>
	</div>
	<!-- 販売期間内の場合 -->
	<div class="cartContainer sort-item"
		v-else-if="!(ptInitData.productInfo.FORM_LP_FLG == 1 && isLp) && ptInitData.productInfo.HANBAI_FLG == 1 && !(ptInitData.siteKbn == '4' && !ptInitData.loginKbn)">
		<!-- 予約商品の場合（販売停止/代替商品 以外） -->
		<template v-if="ptInitData.productInfo.YOYAKU_ITEM_FLG == 1 && !doChkCartAddTxt">
			<img v-if="ptInitData.productInfo.YOYAKU_LIMIT_NUM == 0 || ptInitData.productInfo.NO_LIMIT_FLG == 1"
				src="../img/icons/item-cart-nashi-btn01.png" @error="getErrImage" :alt="$t('common.labels.outStock')"
				id="item-cart-nashi-button" class="cart_order_disabled">
			<template v-else>
				<!-- 定期購入可 -->
				<template
					v-if="(ptInitData.teikiKounyuuOption == 1 && ptInitData.productInfo.TEIKI_KOUNYUU_KANOU_FLG == 1)">
					<input v-if="teikiKounyuu == 0" id="itemCartButton" :value="$t('pt125.labels.cardGeneralBtn')"
						type="button" class="cartOrder" @click="pt125doOrder(1)">
					<input v-else id="itemCartTeikiButton" :value="$t('pt125.labels.cardTeikiBtn')" type="button"
						class="cartTeikiOrder" @click="pt125doOrder(-1)">
				</template>
				<!-- 定期購入不可 -->
				<input v-else id="itemCartButton" :value="$t('pt125.labels.cardBtn')" type="button" class="cartOrder"
					@click="pt125doOrder(1)">
			</template>
		</template>

		<!-- 通常商品の場合 -->
		<template v-else>
			<!-- 欠品 or 販売停止/代替商品でカート追加テキストがある場合 -->
			<img v-if="doChkCartAddTxt || (ptInitData.productInfo.KEPPIN_FLG == 1 && ptInitData.productInfo.CART_ADD_KBN == '1' || ptInitData.productInfo.NYUKAYO_QTY == 0 && ptInitData.productInfo.CART_ADD_KBN == '2' || (ptInitData.hanbaiQtyAvaiable != -999999999 && ptInitData.hanbaiQtyAvaiable <= 0)) || ptInitData.productInfo.NO_LIMIT_FLG == 1"
				src="../img/icons/item-cart-nashi-btn01.png" @error="getErrImage" :alt="$t('common.labels.outStock')"
				id="item-cart-nashi-button" class="cart_order_disabled">
			<template v-else>
				<!-- 定期購入可 -->
				<template
					v-if="(ptInitData.teikiKounyuuOption == 1 && ptInitData.productInfo.TEIKI_KOUNYUU_KANOU_FLG == 1)">
					<input v-if="teikiKounyuu == 0" id="itemCartButton" :value="$t('pt125.labels.cardGeneralBtn')"
						type="button" class="cartOrder" @click="pt125doOrder(1)">
					<input v-else id="itemCartTeikiButton" :value="$t('pt125.labels.cardTeikiBtn')" type="button"
						class="cartTeikiOrder" @click="pt125doOrder(-1)">
				</template>
				<!-- 定期購入不可 -->
				<input v-else id="itemCartButton" :value="$t('pt125.labels.cardBtn')" type="button" class="cartOrder"
					@click="pt125doOrder(1)">
			</template>
		</template>
	</div>

	<!-- 販売期間外の場合 ログイン中-->
	<div class="cartContainer sort-item" v-else-if="!(ptInitData.productInfo.FORM_LP_FLG == 1 && isLp) && ptInitData.productInfo.HANBAI_FLG == 0">
		<div class="outside_sales_period text-danger">
			{{ $t('pt125.labels.outsideSalesPeriod') }}
		</div>
	</div>
	<!-- 販売期間外の場合 or btobログイン前-->
	<div class="cartContainer sort-item" v-else-if="!(ptInitData.productInfo.FORM_LP_FLG == 1 && isLp)">
		<template>
			<input id="itemCartButton" :value="$t('pt125.labels.loginBtn')" type="button" class="cartOrder"
				@click="pt125doOrder(0)">
			<!--btobログイン前でも金額表示する場合「※ログインすると価格が表示されます。」文言は非表示-->
			<div v-if="ptInitData.priceShowBtoB == 0">
				{{ $t('pt125.labels.btobInfo') }}
			</div>
		</template>
	</div>
</template>
<script>
export default {
	name: 'cartContainer',
	props: {
		ptInitData: {
			type: Object,
			default: null
		},
		doChkCartAddTxt: {
			type: Boolean
		},
		isLp:{
			type: Boolean,
			default: false
		},
		teikiKounyuu:{
			type: Number,
			default: 0
		}
	},
	methods: {
		pt125doOrder: function (e) {
			this.$emit('pt125doOrder', e);
		}
	}
}
</script>